import { Button, Divider, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { colors } from "../../styles/color";
import { useNavigate } from "react-router-dom";
import {
  AlertCircle,
  ArrowRight,
  ChannelDone,
  EditIcon,
  Plus,
} from "../../assets/icons";
import BreadCrumb from "../../components/common/BreadCrumb";
import Image from "../../components/common/Image";
import { makeStyles } from "@mui/styles";
import parse from "html-react-parser";
import { EditAccount } from "./EditAccount";
import { useDispatch, useSelector } from "react-redux";
import EmptyInsta from "../dashboard/EmptyInsta";
import {
  fetchAccountDeatils,
  setAccountDetailsState,
} from "../../redux/features/accountDetail/accountDetailSlice";
import userImage from "../../assets/images/p1.png";
import { Helmet } from "react-helmet-async";
type props = {
  access_token?: any;
  accesstoken?: any;
};

const useStyles: any = makeStyles({
  channelLogo: {
    width: "50px",
    height: "50px",
    "@media (max-width: 576px)": {
      width: "32px",
      height: "32px",
    },
  },
});

// Static data for travel stats
const staticTravelData = [
  {
    text: "Followers",
    views: "125K",
    display: true,
  },
  {
    text: "Views",
    views: "2.5M",
    display: true,
  },
  {
    text: "Price Starting At",
    views: "$200",
    display: true,
  },
];

const staticTime = "Weekly (Every Tuesday & Friday)";

export const InstagramPage = () => {
  const [toggle, setToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const classes = useStyles();
  const dispatch = useDispatch();

  // Static data assignments
  const travelData = staticTravelData;
  const time = staticTime;
  const { accountDetails } = useSelector((state: any) => state?.accountDetails);
  const { profileData } = useSelector((state: any) => state?.profile);

  // Get the first Instagram account if available
  const firstInstaAccount = profileData?.insta_accounts?.[0];
  // console.log('profileData: ', profileData?.insta_accounts?.[0].id);

  // Fetch account details when component mounts or when firstInstaAccount changes
  useEffect(() => {
    if (firstInstaAccount?.id) {
      const fetchAccountData = async () => {
        try {
          setLoading(true);
          const response = await dispatch(
            fetchAccountDeatils(firstInstaAccount.id)
          );
          if (response.payload?.status) {
            dispatch(setAccountDetailsState(response.payload.data));
          }
        } catch (error) {
          console.error("Error fetching account details:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchAccountData();
    }
  }, [firstInstaAccount?.id, dispatch]);

  const handleSubmit = () => {
    // Navigate to Instagram account setup
    navigate("/dashboard/add-account");
  };

  const handleEdit = () => {
    setToggle(true);
  };

  const handleChannelClick = (id: number) => {
    // Static handler for channel click
    console.log("Channel clicked:", id);
  };

  return (
    <>
      <Helmet>
        <title>Instagram Creator Dashboard | QuickFluence Influencer Hub</title>
        <meta
          name="description"
          content="Boost Instagram growth with Quickfluence. Add your profile to track followers, engagement, and story metrics with complete creator dashboard insight tools."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://quickfluence.com/" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Quickfluence Dashboard: Add Your Instagram Profile"
        />
        <meta
          property="og:description"
          content="Boost Instagram growth with Quickfluence. Add your profile to track followers, engagement, and story metrics with complete creator dashboard insight tools."
        />
        <meta property="og:url" content="https://quickfluence.com/" />
        <meta property="og:site_name" content="quickfluence" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Instagram profile setup screen on Quickfluence dashboard"
        />
        <meta
          property="og:image"
          content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Box
        sx={{
          "& .MuiAppBar-root": {
            position: "sticky",
          },
        }}
      >
        <Box>
          {!toggle ? (
            <>
              <BreadCrumb
                name1={"Social"}
                name2={"Instagram"}
                isClickable={false}
                isClickable2={true}
                onClick={(e: any) => {
                  e.preventDefault();
                  e.stopPropagation();
                  navigate("/dashboard/social");
                }}
              />
              {!loading ? (
                <Box
                  p="0px 16px"
                  mt={"16px"}
                  mb={"16px"}
                  display={{ md: "flex", xs: "block" }}
                >
                  {!profileData?.insta_accounts ||
                  profileData?.insta_accounts?.length === 0 ||
                  profileData === undefined ? (
                    <EmptyInsta
                      profileData={profileData}
                      handleSubmit={handleSubmit}
                    />
                  ) : (
                    <>
                      {accountDetails ? (
                        <Box
                          sx={{
                            background: colors.dark[800],
                            borderRadius: "12px",
                            mr: { md: "16px", xs: "0px" },
                            flex: "40%",
                            mb: { md: "0px", xs: "20px" },
                            minHeight: {
                              md: "calc(100vh - 132px)",
                              xs: "auto",
                            },
                          }}
                        >
                          <Box
                            p={{ xs: "15px", sm: "30px" }}
                            flexDirection="column"
                            flex="1"
                            display={"flex"}
                            minHeight={{
                              md: "calc(100% - 60px)",
                              xs: "auto",
                            }}
                          >
                            <Box>
                              <Typography
                                variant="h2"
                                sx={{
                                  fontSize: {
                                    xs: "14px",
                                    sm: "16px",

                                    lg: "18px",
                                  },
                                  textAlign: "start",
                                  color: colors.basics.white,
                                }}
                              >
                                My Accounts (
                                {profileData?.insta_accounts?.length || 0})
                              </Typography>
                            </Box>

                            <Box
                              className="border-remove"
                              sx={{
                                cursor: "pointer",
                              }}
                              mt={"24px"}
                              display="flex"
                              bgcolor={colors.dark[600]}
                              borderRadius={"10px"}
                              alignItems="center"
                              justifyContent={"flex-start"}
                              onClick={() =>
                                handleChannelClick(accountDetails?.id)
                              }
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box
                                  sx={{
                                    p: {
                                      sm: "12px 20px 12px 12px",
                                      xs: "12px 10px 12px 12px",
                                    },
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Image
                                    className={classes.channelLogo}
                                    src={accountDetails?.image || userImage}
                                    style={{ borderRadius: "100px" }}
                                    alt="bg-img"
                                  />
                                </Box>
                                <Box display={{ sm: "flex", xs: "none" }}>
                                  <Typography mr="6px">
                                    {accountDetails?.channel_name}
                                  </Typography>
                                  {accountDetails?.channel_name && (
                                    <Typography
                                      variant="body1"
                                      fontSize={{ xs: "14px", sm: "20px" }}
                                      display={"flex"}
                                      alignItems="center"
                                    >
                                      <ChannelDone />
                                    </Typography>
                                  )}
                                </Box>
                                <Box display={{ sm: "none", xs: "flex" }}>
                                  <Typography
                                    variant="h2"
                                    mr="6px"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      textOverflow: "ellipsis",
                                      maxWidth: { sm: "auto", xs: "210px" },
                                      overflow: "hidden",
                                      display: "inline-block",
                                      fontSize: "14px",
                                      // textAlign: 'start',
                                      color: colors.basics.white,
                                    }}
                                  >
                                    {accountDetails?.channel_name}
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    display={"flex"}
                                    ml={{ sm: "-8px", xs: "5px" }}
                                    alignItems="center"
                                  >
                                    <ChannelDone />
                                  </Typography>
                                </Box>
                              </Box>

                              <Box
                                display={"flex"}
                                pr="20px"
                                justifyContent={"flex-end"}
                                flexGrow={1}
                              >
                                <ArrowRight />
                              </Box>
                            </Box>

                            <Button
                              variant="outlined"
                              sx={{ width: "100%", marginTop: "auto" }}
                              startIcon={<Plus />}
                              type="submit"
                              onClick={handleSubmit}
                            >
                              Add Channel
                            </Button>
                          </Box>
                        </Box>
                      ) : (
                        <></>
                      )}

                      {accountDetails ? (
                        <Box
                          sx={{
                            background: colors.dark[800],
                            borderRadius: "12px",
                            flex: "60%",
                          }}
                        >
                          <Box p={{ xs: "15px", sm: "30px" }}>
                            <Box
                              display={"flex"}
                              justifyContent="space-between"
                              alignItems={"center"}
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Box sx={{ p: "12px 20px 12px 0px" }}>
                                  <Image
                                    className={classes.channelLogo}
                                    src={accountDetails?.image || userImage}
                                    height="50px"
                                    width="50px"
                                    style={{ borderRadius: "100px" }}
                                    alt="bg-img"
                                  />
                                </Box>
                                <Box>
                                  <Box
                                    display={{ sm: "flex", xs: "none" }}
                                    sx={{
                                      "& svg": {
                                        height: { sm: "24px", xs: "16px" },
                                        width: { sm: "23px", xs: "16px" },
                                      },
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      fontSize={{ xs: "14px", sm: "20px" }}
                                      sx={{
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        display: "inline-block",
                                        fontSize: "16px",
                                      }}
                                      mr="6px"
                                    >
                                      {accountDetails?.channel_name}
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      fontSize={{ xs: "14px", sm: "20px" }}
                                      sx={{
                                        wordBreak: "break-word",
                                      }}
                                      display={"flex"}
                                      alignItems="center"
                                    >
                                      <ChannelDone />
                                    </Typography>
                                  </Box>
                                  <Box
                                    display={{ sm: "none", xs: "flex" }}
                                    sx={{
                                      "& svg": {
                                        height: { sm: "24px", xs: "16px" },
                                        width: { sm: "23px", xs: "16px" },
                                      },
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      fontSize={{ xs: "14px", sm: "20px" }}
                                      sx={{
                                        wordBreak: "break-word",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        maxWidth: { sm: "auto", xs: "230px" },
                                        overflow: "hidden",
                                        display: "inline-block",
                                      }}
                                      mr="6px"
                                    >
                                      {accountDetails?.channel_name}
                                    </Typography>
                                    <Typography
                                      variant="body1"
                                      fontSize={{ xs: "16px", sm: "20px" }}
                                      sx={{
                                        wordBreak: "break-word",
                                      }}
                                      display={"flex"}
                                      alignItems="center"
                                    >
                                      <ChannelDone />
                                    </Typography>
                                  </Box>
                                  <Typography
                                    color={colors.gray[300]}
                                    variant="body2"
                                    lineHeight={"24px"}
                                    fontWeight={400}
                                    sx={{
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    #{accountDetails?.category?.name}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box>
                                <Box
                                  pr={{ sm: "20px", xs: "0" }}
                                  justifyContent={"flex-end"}
                                  marginLeft={"10px"}
                                  flexGrow={1}
                                  sx={{
                                    "& .MuiButton-root": {
                                      border: `1px solid ${colors.dark[100]}`,
                                      "&:hover": {
                                        border: `1px solid ${colors.dark[100]}`,
                                      },
                                    },
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    sx={{
                                      "& span": {
                                        margin: {
                                          xs: "0",
                                          sm: "0 8px 0 -4px",
                                        },
                                      },
                                      flexShrink: 0,
                                      minWidth: { xs: 0, sm: "64px" },
                                      fontSize: { xs: 0, sm: "16px" },
                                      height: { xs: "auto", sm: "50px" },
                                      padding: { sm: "5px 15px", xs: "10px" },
                                    }}
                                    startIcon={<EditIcon />}
                                    onClick={handleEdit}
                                  >
                                    Edit
                                  </Button>
                                </Box>
                              </Box>
                            </Box>
                            <Box
                              display={{ md: "flex", xs: "block" }}
                              flexDirection={"row"}
                              justifyContent="space-between"
                            >
                              <Box
                                sx={{
                                  m: { sm: "10px", xs: "10px 0px" },
                                  ml: "0",
                                  background: colors.dark[600],
                                  p: "15px 20px",
                                  borderRadius: "12px",
                                  justifyContent: "space-between",
                                  flex: "25%",
                                }}
                              >
                                <Typography
                                  variant="h3"
                                  fontSize={"14px"}
                                  lineHeight={"116.18%"}
                                  color={colors.gray[300]}
                                  pb={"8px"}
                                >
                                  Followers
                                </Typography>
                                <Typography
                                  variant="body2"
                                  textAlign={"left"}
                                  sx={{
                                    fontSize: {
                                      xs: "16px",
                                      sm: "20px",
                                    },
                                  }}
                                >
                                  {accountDetails?.followers_count || "0"}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  m: { sm: "10px", xs: "10px 0px" },
                                  ml: "0",
                                  background: colors.dark[600],
                                  p: "15px 20px",
                                  borderRadius: "12px",
                                  justifyContent: "space-between",
                                  flex: "25%",
                                }}
                              >
                                <Typography
                                  variant="h3"
                                  fontSize={"14px"}
                                  lineHeight={"116.18%"}
                                  color={colors.gray[300]}
                                  pb={"8px"}
                                >
                                  Media
                                </Typography>
                                <Typography
                                  variant="body2"
                                  textAlign={"left"}
                                  sx={{
                                    fontSize: {
                                      xs: "16px",
                                      sm: "20px",
                                    },
                                  }}
                                >
                                  {accountDetails?.media_count || "0"}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  m: { sm: "10px", xs: "10px 0px" },
                                  ml: "0",
                                  background: colors.dark[600],
                                  p: "15px 20px",
                                  borderRadius: "12px",
                                  justifyContent: "space-between",
                                  flex: "25%",
                                }}
                              >
                                <Typography
                                  variant="h3"
                                  fontSize={"14px"}
                                  lineHeight={"116.18%"}
                                  color={colors.gray[300]}
                                  pb={"8px"}
                                >
                                  Price Starting At
                                </Typography>
                                <Typography
                                  variant="body2"
                                  textAlign={"left"}
                                  sx={{
                                    fontSize: {
                                      xs: "16px",
                                      sm: "20px",
                                    },
                                  }}
                                >
                                  {accountDetails?.minimum_price
                                    ? `$${accountDetails.minimum_price}`
                                    : "-"}
                                </Typography>
                              </Box>
                            </Box>
                            <Box mt={"30px"}>
                              <Box>
                                <Typography
                                  variant="h2"
                                  lineHeight={"27px"}
                                  sx={{
                                    fontSize: {
                                      xs: "16px",
                                      sm: "16px",
                                      md: "18px",
                                    },
                                    textAlign: "start",
                                    color: colors.basics.white,
                                  }}
                                >
                                  About channel
                                </Typography>
                              </Box>
                              <Box
                                mt={"20px"}
                                sx={{
                                  "& .MuiTypography-root a": {
                                    color: "#A175FF",
                                    textDecoration: "none",
                                  },
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  fontWeight={400}
                                  lineHeight="24px"
                                  color={colors.gray[300]}
                                >
                                  {parse(accountDetails?.description || "")}
                                </Typography>
                              </Box>
                              <Box mt={"22px"} display={"flex"}>
                                <Box mr={"14px"}>
                                  <AlertCircle />
                                </Box>
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight={400}
                                    lineHeight="24px"
                                    color={colors.gray[300]}
                                  >
                                    Created on {accountDetails?.published_at}
                                  </Typography>
                                </Box>
                              </Box>
                              <Box mt={"23px"}>
                                <img
                                  src={accountDetails?.thumbnail}
                                  height="90px"
                                  width="90px"
                                  style={{
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                  }}
                                  alt="thumbnail"
                                />
                              </Box>
                            </Box>
                            <Box
                              borderTop={`1px solid ${colors.dark[100]}`}
                              mt={"30px"}
                            >
                              <Divider />
                            </Box>
                            <Box mt={"30px"}>
                              <Box>
                                <Typography
                                  variant="h2"
                                  fontSize={{ md: "18px", xs: "16px" }}
                                  lineHeight={"27px"}
                                  sx={{
                                    textAlign: "start",
                                    color: colors.basics.white,
                                  }}
                                >
                                  Other details
                                </Typography>
                              </Box>
                              <Box sx={{ width: "100%" }}>
                                <Box
                                  display={{ sm: "flex", xs: "block" }}
                                  justifyContent="flex-start"
                                  mt={"20px"}
                                >
                                  {accountDetails?.display_video_length !==
                                    "" && (
                                    <Box
                                      flex={"0 0 50%"}
                                      mr={{ sm: "10px", xs: "0px" }}
                                    >
                                      <Typography
                                        variant="body2"
                                        fontWeight={400}
                                        lineHeight="140%"
                                        color={colors.gray[300]}
                                        fontSize="14px"
                                      >
                                        Average video upload duration length
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        lineHeight={"140%"}
                                        mt={"5px"}
                                        fontSize={{ md: 15, xs: 14 }}
                                      >
                                        {accountDetails?.display_video_length}
                                      </Typography>
                                    </Box>
                                  )}
                                  <Box
                                    flex={"0 0 50%"}
                                    mt={{ sm: "0px", xs: "15px" }}
                                  >
                                    <Typography
                                      variant="body2"
                                      fontWeight={400}
                                      lineHeight="140%"
                                      color={colors.gray[300]}
                                      fontSize="14px"
                                    >
                                      Post/Reels upload duration time
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      lineHeight={"140%"}
                                      mt={"5px"}
                                      fontSize={{ md: 15, xs: 14 }}
                                    >
                                      {time}
                                    </Typography>
                                  </Box>
                                </Box>
                                {accountDetails?.countries ? (
                                  <Box
                                    display={{ sm: "flex", xs: "block" }}
                                    justifyContent="flex-start"
                                    mt={"25px"}
                                  >
                                    <Box flex={"0 0 50%"}>
                                      <Typography
                                        variant="body2"
                                        fontWeight={400}
                                        lineHeight="140%"
                                        color={colors.gray[300]}
                                        fontSize="14px"
                                      >
                                        Target audience country
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        lineHeight={"140%"}
                                        mt={"5px"}
                                        fontSize={{ md: 15, xs: 14 }}
                                      >
                                        {accountDetails?.countries
                                          ?.map((value: any) => value.name)
                                          .join(", ")}
                                      </Typography>
                                    </Box>
                                    <Box
                                      flex={"0 0 50%"}
                                      mt={{ sm: "0px", xs: "15px" }}
                                      ml={{ sm: "10px", xs: "0px" }}
                                    >
                                      <Typography
                                        variant="body2"
                                        fontWeight={400}
                                        lineHeight="140%"
                                        color={colors.gray[300]}
                                        fontSize="14px"
                                      >
                                        Post/Reels/Video audio language
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        fontSize={{ md: 15, xs: 14 }}
                                        lineHeight={"140%"}
                                        mt={"5px"}
                                      >
                                        {accountDetails?.audio
                                          .map(
                                            (language: any) => language?.name
                                          )
                                          .join(", ")}
                                      </Typography>
                                    </Box>
                                  </Box>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </Box>
              ) : (
                <></>
              )}
            </>
          ) : (
            <EditAccount
              toggle={toggle}
              setToggle={setToggle}
              accountDetails={accountDetails}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
